'use client';

import styled from '@emotion/styled';

const StyledComparisonColumn = styled.li`
  display: inline-block;
  white-space: normal;
  padding: ${({ theme }) => `1rem 0 1rem ${theme.spacing[400]}`};

  &:first-of-type,
  &:nth-of-type(2) {
    padding-left: 0;
  }

  ${({ theme }) => theme.breakpoint.only('md')} {
    &:nth-of-type(2) {
      padding-left: ${({ theme }) => theme.spacing[600]};
    }
  }
`;

export { StyledComparisonColumn };
